// import TextField from '@mui/material/TextField';
// import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Autocomplete from "@mui/material/Autocomplete";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import InputAdornment from "@mui/material/InputAdornment";
import { BootstrapInput, BootstrapFormControl } from "./StyledForm";

const SearchFilter = ({
    options,
    display,
    formlabel,
    placeholder,
    inputValue,
    onInputChange,
}) => {
    if (typeof display === "undefined") {
        display = true;
    }
    return (
        <Autocomplete
            freeSolo
            inputValue={inputValue}
            onInputChange={onInputChange}
            options={options}
            renderInput={(params) => (
                <BootstrapFormControl display={display}>
                    {formlabel !== undefined ? (
                        <FormLabel>{formlabel}</FormLabel>
                    ) : (
                        ``
                    )}
                    <BootstrapInput
                        ref={params.InputProps.ref}
                        inputProps={params.inputProps}
                        placeholder={placeholder}
                        display={display}
                        endAdornment={
                            <InputAdornment position="end">
                                <ArrowDropDownIcon />
                            </InputAdornment>
                        }
                    />
                </BootstrapFormControl>
            )}
        />
    );
};

export default SearchFilter;
